import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { ClientDetail } from '~/features/ClientDetail';
import { ClientDetailHeader } from '~/features/ClientDetailHeader';

type Props = {
  clientId: number;
};

export const ClientShowScreenContent: React.FC<Props> = ({ clientId }) => {
  return (
    <Suspense fallback={<Loader />}>
      <ClientDetailHeader id={clientId} />
      <ClientDetail id={clientId} />
    </Suspense>
  );
};
